export const ROW_PADDING_OPTIONS = ["8px 18px", "12px 18px", "16px 18px"];

export const toggleRowDensity = (rowDensity: number, setRowDensity: React.Dispatch<React.SetStateAction<number>>) => {
  const newPadding = (rowDensity + 1) % ROW_PADDING_OPTIONS.length;
  setRowDensity(newPadding);
};
